// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IGetVillageListRequestSchema {
  /** Площадь от **/
  areaFrom?: number;
  /** Площадь до **/
  areaTo?: number;
  /** Акция "Черная пятница" **/
  blackFriday?: boolean;
  /** ID застройщика **/
  builderId?: number;
  /** ЖД, шоссе **/
  commuteDistanceType?: ECommuteDistanceType;
  /** Расстояние от МКАДа/КАДа/Центра, до **/
  commuteKmFrom?: number;
  /** Расстояние от МКАДа/КАДа/Центра, от **/
  commuteKmTo?: number;
  /** Статус ручки лидов **/
  cropped?: ECropped;
  /** Срок сдачи. Может быть датой в формате Q.YYYY или строкой "finished" **/
  finishDate?: string;
  /** Этажность от **/
  floorCountFrom?: number;
  /** Этажность до **/
  floorCountTo?: number;
  /** Тип отопления **/
  heatingSourceType?: EHeatingSourceType[];
  /** Материал дома **/
  houseMaterialType?: EHouseMaterialType[];
  /** Явное перечисление списка ID объектов **/
  ids?: number[];
  /** ID локации **/
  locationId?: number;
  /** Тип локации **/
  locationType?: ELocationType;
  /** Тип объектов **/
  newobjectType: ENewobjectType[];
  /** Другие коммуникации **/
  otherCommunications?: EOtherCommunications[];
  /** Номер страницы **/
  p?: number;
  /** Номер страницы **/
  page?: number;
  /** Размер страницы **/
  pageSize?: number;
  /** Стоимость от **/
  priceFrom?: number;
  /** Стоимость до **/
  priceTo?: number;
  /** Статус готовности посёлка **/
  readyStatus?: EReadyStatus[];
  /** ID региона **/
  regionId?: number;
  /** Шоссе **/
  road?: number[];
  /** Расстояние до шоссе **/
  roadDistance?: number;
  /** Статус продаж **/
  saleStatus?: ESaleStatus[];
  /** Тип сортировки **/
  sorting?: ESorting;
  /** Список ID ЖД станций **/
  station?: number[];
  /** Расстояние до ЖД станции **/
  stationDistance?: number;
  /** Просовывается из хедера X-TestMode **/
  testMode?: ETestMode;
  /** Класс посёлка **/
  villageClass: EVillageClass[];
  /** Расположение санузла **/
  wcLocationType?: EWcLocationType;
  /** Сначала сортировать КП с привязанными объявлениями **/
  withDisplayLinksFirst?: boolean;
}

export enum ECommuteDistanceType {
  /** Шоссе **/
  Road = 'road',
  /** Ж/д станция **/
  Station = 'station',
}
export enum ECropped {
  /** Все **/
  All = 'all',
  /** Выключена **/
  Off = 'off',
  /** Включена **/
  On = 'on',
}
export enum EHeatingSourceType {
  /** автономное **/
  Autonomous = 'autonomous',
  /** автономное газовое **/
  AutonomousGas = 'autonomousGas',
  /** бойлер **/
  Boiler = 'boiler',
  /** центральное **/
  Central = 'central',
  /** центр. уголь **/
  Coal = 'coal',
  /** дизельное **/
  Diesel = 'diesel',
  /** электрическое **/
  Electric = 'electric',
  /** камин **/
  Fireplace = 'fireplace',
  /** центр. газ **/
  Gas = 'gas',
  /** есть **/
  Has = 'has',
  /** не указано **/
  None = 'none',
  /** другое **/
  Other = 'other',
  /** твердотопливный котел **/
  SolidFuelBoiler = 'solidFuelBoiler',
  /** печь **/
  Stove = 'stove',
  /** без отопления **/
  Without = 'without',
}
export enum EHouseMaterialType {
  /** газобетонный блок **/
  AerocreteBlock = 'aerocreteBlock',
  /** блочный **/
  Block = 'block',
  /** щитовой **/
  Boards = 'boards',
  /** кирпичный **/
  Brick = 'brick',
  /** custom **/
  Custom = 'custom',
  /** пенобетонный блок **/
  FoamConcreteBlock = 'foamConcreteBlock',
  /** газосиликатный блок **/
  GasSilicateBlock = 'gasSilicateBlock',
  /** монолитный **/
  Monolith = 'monolith',
  /** монолитно кирпичный **/
  MonolithBrick = 'monolithBrick',
  /** не указано **/
  None = 'none',
  /** старый фонд **/
  Old = 'old',
  /** панельный **/
  Panel = 'panel',
  /** сталинский **/
  Stalin = 'stalin',
  /** каркасный **/
  Wireframe = 'wireframe',
  /** деревянный **/
  Wood = 'wood',
}
export enum ELocationType {
  /** Страна **/
  Country = 'country',
  /** Район **/
  District = 'district',
  /** Дом **/
  House = 'house',
  /** Местоположение (город / область) **/
  Location = 'location',
  /** Шоссе **/
  Road = 'road',
  /** Улица **/
  Street = 'street',
  /** Метро **/
  Underground = 'underground',
}
export enum ENewobjectType {
  /** Коттедж **/
  Cottage = 'cottage',
  /** Участок **/
  Landplot = 'landplot',
  /** Малоэтажный дом **/
  Lowrisehouse = 'lowrisehouse',
  /** Таунхаус **/
  Townhouse = 'townhouse',
}
export enum EOtherCommunications {
  /** Канализация **/
  Drainage = 'drainage',
  /** Электричество **/
  Electricity = 'electricity',
  /** Газ **/
  Gas = 'gas',
  /** Водоснабжение **/
  Water = 'water',
}
export enum EReadyStatus {
  /** Строится **/
  Building = 'building',
  /** Построен **/
  Built = 'built',
  /** Заморожен **/
  Frozen = 'frozen',
  /** Планируется **/
  Planning = 'planning',
}
export enum ESaleStatus {
  /** Завершены **/
  Closed = 'closed',
  /** Открыты **/
  Opened = 'opened',
  /** Ожидание **/
  Pending = 'pending',
}
export enum ESorting {
  /** По качеству контента **/
  ByContentScore = 'byContentScore',
  /** По расстоянию от МКАД (КАД для ЛО и СПб, Центра для регионов) по возрастанию расстояния **/
  Commute = 'commute',
  /** По умолчанию (по количеству объектов в общем статусе активный по убыванию) **/
  Default = 'default',
  /** По средней площади дома по возрастанию **/
  HouseArea = 'houseArea',
  /** По ID по возрастанию **/
  Id = 'id',
  /** По средней площади участка по возрастанию **/
  LandplotArea = 'landplotArea',
  /** По средней цене по возрастанию **/
  Price = 'price',
  /** По расстоянию до вокзала **/
  TerminalDistance = 'terminalDistance',
}
export enum ETestMode {
  /** Отдаеём и нарнийные и обычные КП **/
  Mixed = 'mixed',
  /** Отключен **/
  Off = 'off',
  /** Отдаём только нарнийные КП **/
  Strict = 'strict',
}
export enum EVillageClass {
  /** Бизнес **/
  Business = 'business',
  /** Комфорт **/
  Comfort = 'comfort',
  /** Эконом **/
  Economy = 'economy',
  /** Элит **/
  Elite = 'elite',
}
export enum EWcLocationType {
  /** В доме **/
  Indoors = 'indoors',
  /** Не указано **/
  None = 'none',
  /** На улице **/
  Outdoors = 'outdoors',
}
